import {
  ApiService,
  type User,
  type CreateUserRequest,
  type UpdateUserRequest,
  type UsersPaginatedResponse,
  type UserQuery,
} from './api.service'

export class UserService extends ApiService {
  /**
   * Get all users with pagination
   */
  async getUsers(query?: UserQuery): Promise<UsersPaginatedResponse> {
    return this.handleResponse(this.api.get<UsersPaginatedResponse>('/users', { params: query }))
  }

  /**
   * Get a user by ID
   */
  async getUserById(id: string): Promise<User> {
    return this.handleResponse(this.api.get<User>(`/users/${id}`))
  }

  /**
   * Create a new user
   */
  async createUser(userData: CreateUserRequest): Promise<User> {
    return this.handleResponse(this.api.post<User>('/users', userData))
  }

  /**
   * Update a user
   */
  async updateUser(id: string, userData: UpdateUserRequest): Promise<User> {
    return this.handleResponse(this.api.patch<User>(`/users/${id}`, userData))
  }

  /**
   * Delete a user
   */
  async deleteUser(id: string): Promise<void> {
    return this.handleResponse(this.api.delete<void>(`/users/${id}`))
  }
}

// Export singleton instance
export const userService = new UserService()
